import React from 'react'
import { Title, BodyWrapper } from './UrinaryBenefits.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { Article } from 'components/Sections/Article'

export const UrinaryBenefits: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Article background="secondary">
      <Title id="urinary-benefits-title">{t('raw-benefits:urinary-benefits.title')}</Title>

      <BodyWrapper>
        <Text>{t('raw-benefits:urinary-benefits.body.0')}</Text>
        <Text>{t('raw-benefits:urinary-benefits.body.1')}</Text>
        <Text>{t('raw-benefits:urinary-benefits.body.2')}</Text>
      </BodyWrapper>
    </Article>
  )
}

UrinaryBenefits.displayName = 'UrinaryBenefits'
